var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "icon-container"
  }, [_c("a-list", {
    attrs: {
      grid: {
        gutter: 16,
        column: 6
      },
      "data-source": _vm.localIcon
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function (item) {
        return _c("a-list-item", {}, [_c("div", {
          staticClass: "text-center pointer icon-wrapper",
          on: {
            "!click": function ($event) {
              $event.stopPropagation();
              return _vm.handleCopy(item, $event);
            }
          }
        }, [_c("svg-icon", {
          staticClass: "disabled",
          attrs: {
            icon: item,
            size: 30
          }
        }), _c("div", {
          staticStyle: {
            "margin-top": "8px"
          }
        }, [_vm._v(_vm._s(item))])], 1)]);
      }
    }])
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };